import { getStoredSessionToken } from './sessionTokens';

export const PLAYER_IDLE_MS = 30 * 60 * 1000;
export const PLAYER_IDLE_EVENT = 'vl:player-idle-expired';
// Display-only, tab-memory cache. Never persist accounts/passwords to browser storage.
let session = { key: '', snapshot: null, sections: {}, lastActivity: 0, revision: 0 };
export const playerLobbyKey = user => user?.id
  ? JSON.stringify([user.tenant_id || user.tenant_slug || '', user.id, getStoredSessionToken()]) : '';

export function selectPlayerSession(key, now = Date.now()) {
  if (session.key !== key) session = { key, snapshot: null, sections: {}, lastActivity: now, revision: session.revision + 1 };
  return session.revision;
}
export function recordPlayerActivity(now = Date.now()) {
  if (!session.key) return false;
  const expired = now - session.lastActivity >= PLAYER_IDLE_MS;
  if (expired) { session.snapshot = null; session.sections = {}; session.revision += 1; }
  session.lastActivity = now;
  return expired;
}
export const playerSessionRevision = () => session.revision;
export const playerRecoveryPending = () => Boolean(session.recovering);
export function invalidatePlayerLobby() {
  session.snapshot = null; session.sections = {}; session.revision += 1; session.recovering = true;
}
export function readPlayerLobby(key, now = Date.now()) {
  return key && key === session.key && now - session.lastActivity < PLAYER_IDLE_MS ? session.snapshot : null;
}
export function savePlayerLobby(key, revision, snapshot) {
  if (key && key === session.key && revision === session.revision) { session.snapshot = snapshot; session.recovering = false; }
}
export function readPlayerSection(key, section) {
  return key && key === session.key && Date.now() - session.lastActivity < PLAYER_IDLE_MS ? session.sections[section] : null;
}
export function savePlayerSection(key, revision, section, data) {
  if (key && key === session.key && revision === session.revision) session.sections[section] = data;
}
